import React, { useEffect, useRef } from "react";

export default function Adsense() {
  const adRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {}
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="ads-container">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          height: "0px",
          margin: 0,
          padding: 0,
        }}
        data-ad-client="ca-pub-4942463590341754"
        data-ad-slot="4116738356"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}